<div [class.spot-service-manager]="currentStep === 13">
  <div class="spot-overlay"></div>
  <markant-platform-management-view
    slot="highlight-dialog-static-view-content"
    [demoContent]="demoService"
  ></markant-platform-management-view>
</div>
